import React, { Component } from 'react';
// import { ChromePicker } from "react-color";
import { ColorPicker, useColor } from 'react-color-palette';
import 'react-color-palette/lib/css/styles.css';

import { inArray, l } from '../functions';
import Icon from './Icons';
import SliderRange from './SliderRange';
import { connect } from 'react-redux';

function mapStateToProps(state) {
  return {
    recentColor: state.rootReducer?.recentColors || null,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    addToRecent: (color) => {
      dispatch({ type: 'ADD_RECENT_COLOR', color: color });
    },
  };
}

// utility functions for color class

function rgbaToHex(orig = '') {
  if (!orig?.length) {
    return '#000000';
  }
  var rgb = orig.replace(/\s/g, '').match(/^rgba?\((\d+),(\d+),(\d+),?([^,\s)]+)?/i),
    hex = rgb
      ? (rgb[1] | (1 << 8)).toString(16).slice(1) +
        (rgb[2] | (1 << 8)).toString(16).slice(1) +
        (rgb[3] | (1 << 8)).toString(16).slice(1)
      : orig;

  return hex;
}

function hexToRgba(hex = '') {
  if (!hex?.length) {
    return 'rgba(0,0,0,1)';
  }
  var c;
  if (isHex(hex)) {
    c = hex.substring(1).split('');
    if (c.length == 3) c = [c[0], c[0], c[1], c[1], c[2], c[2]];

    c = '0x' + c.join('');
    return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',1)';
  }
}

function getAlpha(orig = '') {
  if (!orig?.length) {
    return 100;
  }
  var a,
    rgb = orig.replace(/\s/g, '').match(/^rgba?\((\d+),(\d+),(\d+),?([^,\s)]+)?/i),
    alpha = ((rgb && rgb[4]) || '').trim();

  if (alpha !== '') a = alpha;
  else a = 1;

  return a * 100;
}

function visibleColor(color) {
  if (!color) {
    return '#000000';
  }
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(color)) return color;
  else return rgbaToHex(color);
}

function isHex(color) {
  return /^#([A-Fa-f0-9]{3}){1,2}$/.test(color);
}

function setAlpha(color, opacity) {
  let rgbaColor;

  if (isHex(color)) rgbaColor = hexToRgba(color);
  else rgbaColor = color;

  const rgb = rgbaColor.replace(/\s/g, '').match(/^rgba?\((\d+),(\d+),(\d+),?([^,\s)]+)?/i);
  const alpha = opacity / 100;
  if (rgb?.length) return 'rgba(' + rgb[1] + ',' + rgb[2] + ',' + rgb[3] + ',' + alpha + ')';
  else return 'rgba(0,0,0,' + alpha + ')';
}

function hexToRgb(hex) {
  if (hex?.length === 4) {
    hex = '#' + hex[1] + hex[1] + hex[2] + hex[2] + hex[3] + hex[3];
  }
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
}

function rgbToHsl({ r, g, b }) {
  r = r / 255;
  g = g / 255;
  b = b / 255;

  var max = Math.max(r, g, b),
    min = Math.min(r, g, b);
  var h,
    s,
    l = (max + min) / 2;

  if (max == min) {
    h = s = 0; // achromatic
  } else {
    var d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

    switch (max) {
      case r:
        // h = (g - b) / d + (g < b ? 6 : 0);
        h = (g - b) / d;
        break;
      case g:
        // h = (b - r) / d + 2;
        h = 2 + (b - r) / d;
        break;
      case b:
        // h = (r - g) / d + 4;
        h = 4 + (r - g) / d;
        break;
    }

    h *= 60;
    if (h < 0) h = h + 360;
  }

  return { h: Math.round(h), s: Math.round(s * 100), l: Math.round(l * 100) };
}

function SpectrumColorPalette({ onColorChange = () => {}, color: sColor }) {
  const [cColor, setCColor] = useColor('hex', sColor);

  return (
    <ColorPicker
      color={cColor}
      onChangeComplete={(color) => {
        // console.log(color);
        onColorChange(color.hex);
      }}
      onChange={(color) => {
        setCColor(color);
      }}
      width={222}
      height={124}
      hideHEX
      hideHSV
      hideRGB
      dark
    />
  );
}

function setFavorits({ color = '', preColors = [] }) {
  if (preColors.includes(color) || color === '') {
    return;
  }
  let colorString = preColors.reduce((p, c) => p + `${p ? '|' : ''}` + c, '');
  colorString = colorString + '|' + color;
  document.cookie = `gk_user_color=${colorString};max-age:604800`;
}

function getSavedColors() {
  const cookies = document.cookie;
  const allCookies = cookies.split(';');
  const favCookie = allCookies.filter((item) => item.includes('gk_user_color'));
  const rawColors = favCookie[0]?.split('=')[1];
  return rawColors?.split('|') || [];
}

function HSLToRGB({ h, s, l }) {
  s /= 100;
  l /= 100;
  const k = (n) => (n + h / 30) % 12;
  const a = s * Math.min(l, 1 - l);
  const f = (n) => l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
  return { r: 255 * f(0), g: 255 * f(8), b: 255 * f(4) };
}

function componentToHex(c) {
  if (typeof c === 'string') {
    c = parseInt(c);
  }
  var hex = c?.toString(16);

  return hex.length == 1 ? '0' + hex : hex;
}

function rgbToHex({ r, g, b }) {
  const color = '#' + componentToHex(r) + componentToHex(g) + componentToHex(b);
  return color;
}

class NewColorPicker extends Component {
  constructor(props) {
    super(props);

    this.state = {
      color: this.props.color || '',
      hex: visibleColor(this.props.color || '#000000'),
      activeDropdown: null,
      picker: false,
      dropDown: false,
      currentColorTab: 'grid',
      currentColorScheme: 'hex',
      colorOpecity: getAlpha(isHex(this.props.color) ? hexToRgba(this.props.color) : this.props.color) || 100,
      rgb: hexToRgb(visibleColor(this.props.color || '#000000')),
      hsl: rgbToHsl(
        hexToRgb(visibleColor(this.props.color || '#000000')) || {
          r: 0,
          b: 0,
          g: 0,
        }
      ),
      colorError: null,
    };

    this.colorFamilies = [
      {
        default: '#478df7',
        colors: ['#07172e', '#143b78', '#1e53a8', '#478df7', '#75abf9', '#afcffb', '#deebfd'],
      },
      {
        default: '#d34e71',
        colors: ['#250c14', '#611e30', '#942f49', '#d34e71', '#d96c8b', '#e7aabd', '#f7dfe7'],
      },
      {
        default: '#7b8899',
        colors: ['#101823', '#232d3b', '#3d4b55', '#7b8899', '#afb7c1', '#d4d8de', '#f1f2f4'],
      },
      {
        default: '#eb5750',
        colors: ['#350705', '#6a1914', '#cb3228', '#eb5750', '#ed7571', '#f3adab', '#fadcdc'],
      },
      {
        default: '#60c96b',
        colors: ['#122a17', '#28592f', '#3e8647', '#60c96b', '#71de83', '#96e9ab', '#b5f2c6'],
      },
      {
        default: '#f8cd4f',
        colors: ['#5a280e', '#90511b', '#c38a2f', '#f8cd4f', '#f6d877', '#f9e5a1', '#fcf4db'],
      },
      {
        default: '#586ebe',
      },
      {
        default: '#3559c5',
      },
      {
        default: '#3c70ae',
      },
      {
        default: '#c4cfec',
      },
    ];

    this.gridPalettes = [
      [
        {
          default: '#000000',
        },
        {
          default: '#434343',
        },
        {
          default: '#666666',
        },
        {
          default: '#999999',
        },
        {
          default: '#b7b7b7',
        },
        {
          default: '#cccccc',
        },
        {
          default: '#d9d9d9',
        },
        {
          default: '#efefef',
        },
        {
          default: '#f3f3f3',
        },
        {
          default: '#ffffff',
        },
      ],
      [
        {
          default: '#980000',
        },
        {
          default: '#ff0000',
        },
        {
          default: '#ff9900',
        },
        {
          default: '#ffff00',
        },
        {
          default: '#00ff00',
        },
        {
          default: '#00ffff',
        },
        {
          default: '#4a86e8',
        },
        {
          default: '#0000ff',
        },
        {
          default: '#9900ff',
        },
        {
          default: '#ff00ff',
        },
      ],
      [
        {
          default: '#e6b8af',
        },
        {
          default: '#f4cccc',
        },
        {
          default: '#fce5cd',
        },
        {
          default: '#fff2cc',
        },
        {
          default: '#d9ead3',
        },
        {
          default: '#d0e0e3',
        },
        {
          default: '#c9daf8',
        },
        {
          default: '#cfe2f3',
        },
        {
          default: '#d9d2e9',
        },
        {
          default: '#ead1dc',
        },
      ],
      [
        {
          default: '#dd7e6b',
        },
        {
          default: '#ea9999',
        },
        {
          default: '#f9cb9c',
        },
        {
          default: '#ffe599',
        },
        {
          default: '#b6d7a8',
        },
        {
          default: '#a2c4c9',
        },
        {
          default: '#a4c2f4',
        },
        {
          default: '#9fc5e8',
        },
        {
          default: '#b4a7d6',
        },
        {
          default: '#d5a6bd',
        },
      ],
      [
        {
          default: '#cc4125',
        },
        {
          default: '#e06666',
        },
        {
          default: '#f6b26b',
        },
        {
          default: '#ffd966',
        },
        {
          default: '#93c47d',
        },
        {
          default: '#76a5af',
        },
        {
          default: '#6d9eeb',
        },
        {
          default: '#6fa8dc',
        },
        {
          default: '#8e7cc3',
        },
        {
          default: '#c27ba0',
        },
      ],
      [
        {
          default: '#a61c00',
        },
        {
          default: '#cc0000',
        },
        {
          default: '#e69138',
        },
        {
          default: '#f1c232',
        },
        {
          default: '#6aa84f',
        },
        {
          default: '#45818e',
        },
        {
          default: '#3c78d8',
        },
        {
          default: '#3d85c6',
        },
        {
          default: '#674ea7',
        },
        {
          default: '#a64d79',
        },
      ],
      [
        {
          default: '#85200c',
        },
        {
          default: '#990000',
        },
        {
          default: '#b45f06',
        },
        {
          default: '#bf9000',
        },
        {
          default: '#38761d',
        },
        {
          default: '#134f5c',
        },
        {
          default: '#1155cc',
        },
        {
          default: '#0b5394',
        },
        {
          default: '#351c75',
        },
        {
          default: '#741b47',
        },
      ],
      [
        {
          default: '#5b0f00',
        },
        {
          default: '#660000',
        },
        {
          default: '#783f04',
        },
        {
          default: '#7f6000',
        },
        {
          default: '#274e13',
        },
        {
          default: '#0c343d',
        },
        {
          default: '#1c4587',
        },
        {
          default: '#073763',
        },
        {
          default: '#20124d',
        },
        {
          default: '#4c1130',
        },
      ],
    ];
  }

  // react class component lifecycle function
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.color !== this.state.color) {
      if (this.state.hex) {
        this.props.addToRecent(this.state.hex);
      }

      this.props.onChangeComplete(this.state.color);
    }
  }

  componentWillReceiveProps({ color, show = true }) {
    if (color !== this.props.color && color !== this.state.color)
      this.setState({ color: setAlpha(color, this.state.colorOpecity) });
    if (!show) {
      // this.setState({ dropDown: true });
    }
  }

  // class private functions

  _showToolTip = () => {
    if (this.state.colorOpecity < 100) {
      this.setState({ showToolTip: true }, () => {
        setTimeout(() => {
          this.setState({ showToolTip: false });
        }, 1000);
      });
    }
  };

  _dropDown = (target) => {
    this.setState({ activeDropdown: target });
  };

  _dropUp = () => {
    this.setState({ activeDropdown: null });
  };

  _generateColor = () => {
    const scope = this;
    let colors = [];

    this.colorFamilies.forEach((familly, fkey) => {
      const inColor =
        (familly.colors && inArray(scope.state.color, familly.colors)) || scope.state.color === familly.default;
      const mainColor = inColor ? this.state.color : familly.default;

      colors.push(
        <div
          key={fkey}
          onMouseEnter={() => {
            scope._dropDown(fkey);
          }}
          onMouseLeave={() => {
            scope._dropUp();
          }}
        >
          <button
            style={{ backgroundColor: mainColor }}
            onClick={() => {
              if (!familly.colors)
                this.setState(
                  {
                    color: setAlpha(familly.default, this.state.colorOpecity),
                    hex: familly.default,
                  },
                  () => this._showToolTip()
                );
            }}
          >
            {inColor && <Icon icon='check' />}
          </button>

          {scope.state.activeDropdown === fkey && familly.colors && (
            <div className='drop-down'>
              {familly.colors.map((color, ckey) => (
                <button
                  key={ckey}
                  onClick={() => {
                    this.setState(
                      {
                        color: setAlpha(color, this.state.colorOpecity),
                        hex: color,
                        activeDropdown: null,
                        //   dropDown: false,
                      },
                      () => {
                        this._setColorsState({ type: 'hex', color: color });
                        this._showToolTip();
                      }
                    );
                  }}
                  style={{ backgroundColor: color }}
                ></button>
              ))}
            </div>
          )}
        </div>
      );
    });

    return colors;
  };

  _generateColorGridPalette = () => {
    return (
      <>
        <div className='grid-palette'>
          {this.gridPalettes.map((colorList, index) => {
            return (
              <div className='grid-palette-row'>
                {colorList.map((color, i) => (
                  <>
                    <div
                      key={'' + index + i}
                      onClick={() => {
                        this.setState(
                          {
                            color: setAlpha(color.default, this.state.colorOpecity),

                            activeDropdown: null,
                            //   dropDown: false,
                          },
                          () => {
                            this._setColorsState({
                              type: 'hex',
                              color: color.default,
                            });
                            this._showToolTip();
                          }
                        );
                      }}
                      style={{ backgroundColor: color.default }}
                      className={`${this.state.hex === color.default ? 'active' : ''}`}
                    >
                      {this.state.hex === color.default && <Icon icon={'check'} />}
                    </div>
                  </>
                ))}
              </div>
            );
          })}
        </div>
      </>
    );
  };

  _generateFavColor = () => {
    const savedColors = getSavedColors() || [];

    return (
      <>
        <div className='heading'>
          <label style={{ color: 'white', fontSize: 14, fontWeight: 500 }}>Favorites</label>
          <button
            onClick={() => {
              setFavorits({ color: this.state.hex, preColors: savedColors });
              this.setState(
                {
                  color: setAlpha(this.state.hex, this.state.colorOpecity),
                },
                () => {
                  this._setColorsState({ type: 'hex', color: this.state.hex });
                  this._showToolTip();
                }
              );
            }}
          >
            <Icon icon='plus' />
          </button>
        </div>
        <div className='favorit-colors'>
          {savedColors.map((color, index) => {
            return color ? (
              <div
                key={index}
                style={{ backgroundColor: color }}
                onClick={() => {
                  this.setState(
                    {
                      color: setAlpha(color, this.state.colorOpecity),
                      hex: color,
                      activeDropdown: null,
                      //   dropDown: false,
                    },
                    () => this._showToolTip()
                  );
                }}
              >
                {' '}
                {this.state.hex === color && <Icon icon='check' />}{' '}
              </div>
            ) : null;
          })}
        </div>
      </>
    );
  };

  _generateRecentColor = () => {
    const savedColors = this.props.recentColor || [];
    return (
      <>
        <div className='heading'>
          <label style={{ color: 'white', fontSize: 14, fontWeight: 500 }}>Recent</label>
        </div>
        <div className='favorit-colors'>
          {savedColors.map((color, index) => {
            return color ? (
              <div
                key={index}
                style={{ backgroundColor: color }}
                onClick={() => {
                  this.setState(
                    {
                      color: setAlpha(color, this.state.colorOpecity),
                      hex: color,
                      activeDropdown: null,
                      //   dropDown: false,
                    },
                    () => this._showToolTip()
                  );
                }}
              >
                {this.state.hex === color && <Icon icon='check' />}
              </div>
            ) : null;
          })}
        </div>
      </>
    );
  };

  _setColorsState = ({ type = 'hex', color = '' }) => {
    let hex, hsl, rgb;

    switch (type) {
      case 'hex':
        if (!isHex(color)) {
          this.setState({ hex: color });
          return;
        }
        hex = color;
        rgb = hexToRgb(hex);
        hsl = rgbToHsl(rgb);

        this.setState({ hex, rgb, hsl });

        break;
      case 'rgb':
        hex = rgbToHex(color);
        hsl = rgbToHsl(color);
        this.setState({ hex, rgb: color, hsl });

        break;
      case 'hsl':
        rgb = HSLToRGB(color);
        hex = rgbToHex(rgb);
        this.setState({ hex, rgb, hsl: color });

        break;
    }
  };

  _generateRGBScheme = () => {
    const rgb = this.state.rgb;
    return (
      <>
        <input
          value={rgb?.r || 0}
          min={0}
          max={255}
          onChange={(e) => {
            let value = e.target.value;
            this._setColorsState({ type: 'rgb', color: { ...rgb, r: value } });
          }}
        />
        <input
          value={rgb?.g || 0}
          min={0}
          max={255}
          onChange={(e) => {
            let value = e.target.value;
            this._setColorsState({ type: 'rgb', color: { ...rgb, g: value } });
          }}
        />
        <input
          value={rgb?.b || 0}
          min={0}
          max={255}
          onChange={(e) => {
            let value = e.target.value;
            this._setColorsState({ type: 'rgb', color: { ...rgb, b: value } });
          }}
        />
      </>
    );
  };
  _generateHSLScheme = () => {
    const hsl = this.state.hsl;
    return (
      <>
        <input
          value={hsl?.h || 0}
          min={0}
          max={360}
          onChange={(e) => {
            let value = e.target.value;
            this._setColorsState({ type: 'hsl', color: { ...hsl, h: value } });
          }}
        />
        <input
          value={hsl?.s || 0}
          min={0}
          max={100}
          onChange={(e) => {
            let value = e.target.value;
            this._setColorsState({ type: 'hsl', color: { ...hsl, s: value } });
          }}
        />
        <input
          value={hsl?.l || 0}
          min={0}
          max={100}
          onChange={(e) => {
            let value = e.target.value;
            this._setColorsState({ type: 'hsl', color: { ...hsl, l: value } });
          }}
        />
      </>
    );
  };

  render() {
    return (
      <div className={`color-setter ${this.props.align || 'left'} `}>
        {this.props.quickbar && (
          <div
            className='color-select quickbar'
            style={{ backgroundColor: this.state.color }}
            onClick={() => {
              this.setState({ dropDown: !this.state.dropDown });
              this.props.onClick && this.props.onClick();
            }}
          >
            <span class='quickbartext'>{this.props.tooltipTitle}</span>
          </div>
        )}
        {!this.props.quickbar && (
          <div
            className='color-select'
            style={{ backgroundColor: this.state.color }}
            onClick={() => {
              this.setState({ dropDown: !this.state.dropDown });
            }}
          >
            <Icon icon='dropdown' />
          </div>
        )}

        {this.state.dropDown && (
          <div className={`dropdown-setter ${this.props.up ? 'up' : ''}  ${this.props.right ? 'right' : ''}`}>
            <Icon
              icon='time'
              onClick={() => {
                this.setState({ dropDown: false });
              }}
            />
            <div>
              <div>
                <button
                  onClick={() => {
                    this.setState(
                      {
                        color: setAlpha('#ffffff', this.state.colorOpecity),
                        hex: '#ffffff',
                      },
                      () => this._showToolTip()
                    );
                  }}
                  style={{ backgroundColor: 'white' }}
                ></button>
              </div>
              <div>
                <button
                  onClick={() => {
                    this.setState(
                      {
                        hex: '#000000',
                        color: setAlpha('#000000', this.state.colorOpecity),
                      },
                      () => this._showToolTip()
                    );
                  }}
                  style={{ backgroundColor: 'black' }}
                ></button>
              </div>
              <div>
                <button
                  onClick={() => {
                    this.setState({ color: setAlpha(this.state.color, 0) });
                  }}
                >
                  <Icon icon='transparency' />
                </button>
              </div>
              <div>
                <button
                  onClick={() => {
                    this.setState({
                      color: '',
                      hex: '',
                      activeDropdown: null,
                      dropDown: false,
                    });
                  }}
                  className='no-color'
                >
                  <span>{l('No Color')}</span>
                </button>
              </div>
              {/* <div>
                <button
                  className="round"
                  style={{ backgroundColor: this.state.color || "white" }}
                  onClick={() => {
                    this.setState({ picker: true });
                  }}
                >
                  &nbsp;
                </button>{" "}
                <span
                  onClick={() => {
                    this.setState({ picker: true });
                  }}
                >
                  {visibleColor(this.state.color)}
                </span>
                {this.state.picker && (
                  <div className="picker">
                    <Icon
                      icon="time"
                      onClick={() => {
                        this.setState({ picker: false });
                      }}
                    />
                    <ChromePicker
                      color={this.state.color}
                      onChange={(color) => {
                        this.setState({ color: color.hex });
                      }}
                      disableAlpha={true}
                    />
                  </div>
                )}
              </div> */}
            </div>
            <div>{this._generateColor()}</div>
            <div style={{ margin: '10px 0' }}>{this._generateRecentColor()}</div>
            <div style={{ margin: '10px 0' }}>{this._generateFavColor()}</div>
            <div
              className='opacity-range'
              style={this.state.color ? { opacity: 1, pointerEvents: 'all' } : { opacity: 0.4, pointerEvents: 'none' }}
            >
              <span style={{ color: 'white', fontSize: 14 }}>Transparency</span>
              {this.state.showToolTip && <span className='alert-tooltip'>The exact color may be visible at 100%</span>}
              <SliderRange
                value={getAlpha(isHex(this.state.color) ? hexToRgba(this.state.color) : this.state.color)}
                min={0}
                max={100}
                onChange={(value) => {
                  this.setState({
                    color: setAlpha(this.state.color, value),
                    colorOpecity: value,
                  });
                }}
                style={{ marginTop: 0 }}
              />
            </div>

            {/* New Color Picker Design and Options */}

            <div className='new-color-palettes'>
              <ul className='color-tabs'>
                <li
                  className={`${this.state.currentColorTab === 'grid' ? 'active' : ''}`}
                  onClick={() => {
                    this.setState({ currentColorTab: 'grid' });
                  }}
                >
                  <span>{l('Grid')}</span>
                </li>
                <li
                  className={`${this.state.currentColorTab === 'spectrum' ? 'active' : ''}`}
                  onClick={() => {
                    this.setState({ currentColorTab: 'spectrum' });
                  }}
                >
                  <span> {l('Spectrum')}</span>
                </li>
              </ul>

              {this.state.currentColorTab === 'grid' && (
                <>
                  {/* Color Grid here */}
                  {this._generateColorGridPalette()}
                </>
              )}
              {this.state.currentColorTab === 'spectrum' && (
                // <ChromePicker
                //   color={this.state.color}
                //   onChange={(color) => {
                //     this.setState({ color: color.hex });
                //   }}
                //   disableAlpha={false}
                // />
                <SpectrumColorPalette
                  onColorChange={(color) =>
                    this.setState(
                      {
                        color: setAlpha(color, this.state.colorOpecity),
                        hex: color,
                      },
                      () => this._showToolTip()
                    )
                  }
                  color={this.state.hex}
                />
              )}

              {/* HEX-RGB-HSL tabs */}

              <div className='color-schemes'>
                <ul className='color-scheme-options'>
                  <li
                    className={`${this.state.currentColorScheme === 'hex' ? 'active' : ''}`}
                    onClick={() => {
                      this.setState({ currentColorScheme: 'hex' });
                    }}
                  >
                    {l('HEX')}
                  </li>
                  <li
                    className={`${this.state.currentColorScheme === 'rgb' ? 'active' : ''}`}
                    onClick={() => {
                      this.setState({ currentColorScheme: 'rgb' });
                    }}
                  >
                    {l('RGB')}
                  </li>
                  <li
                    className={`${this.state.currentColorScheme === 'hsl' ? 'active' : ''}`}
                    onClick={() => {
                      this.setState({ currentColorScheme: 'hsl' });
                    }}
                  >
                    {l('HSL')}
                  </li>
                </ul>
                <div className='color-scheme-tab'>
                  <div className='scheme-tabs'>
                    {this.state.currentColorScheme === 'hex' && (
                      <>
                        <input
                          className='hex'
                          value={this.state.hex?.toUpperCase()}
                          onChange={(e) => {
                            let value = e.target.value;
                            if (!value.includes('#')) {
                              value = '#' + value;
                            }
                            if (!isHex(value)) {
                              this.setState({
                                colorError: 'Not a valid color',
                              });
                            } else {
                              this.setState({ colorError: null });
                            }
                            this._setColorsState({ type: 'hex', color: value });
                          }}
                        />
                        {this.state.colorError && <span className='my-tooltip'>{this.state.colorError}</span>}
                      </>
                    )}
                    {this.state.currentColorScheme === 'rgb' && (
                      <>
                        {/* show RGB values of current color */}
                        {this._generateRGBScheme()}
                      </>
                    )}
                    {this.state.currentColorScheme === 'hsl' && (
                      <>
                        {/* Show HSL values of current color */}
                        {this._generateHSLScheme()}
                      </>
                    )}
                  </div>

                  <button
                    onClick={() => {
                      const alphaColor = setAlpha(this.state.hex, this.state.colorOpecity);
                      this.setState({ color: alphaColor });
                      this._showToolTip();
                      this.setState({ dropDown: false });
                    }}
                    disabled={this.state.colorError}
                  >
                    <Icon icon='check' />
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NewColorPicker);
